module.exports = __webpack_public_path__ + "img/Zug_Technik_und_Sicherheit.8b4cf534.svg";